import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var DropTargetImpl = /*#__PURE__*/function () {
  function DropTargetImpl(spec, monitor) {
    _classCallCheck(this, DropTargetImpl);

    this.spec = spec;
    this.monitor = monitor;
  }

  _createClass(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }

      return;
    }
  }]);

  return DropTargetImpl;
}();